import { create } from 'zustand';

import { Documentacion } from '@/shared/interfaces/erp/documentos/Documentacion';

interface DocumentacionContratoStore {
  ///* state
  documentos: Documentacion[];

  ///* actions
  setDocumentos: (documentos: Documentacion[]) => void;
  addDocumento: (documento: Documentacion) => void;
  removeDocumento: (id: string) => void;
  resetDocumentos: () => void;
}

export const useDocumentacionContratoStore = create<DocumentacionContratoStore>(
  (set, get) => ({
    documentos: [],

    setDocumentos: (documentos) => set({ documentos }),

    addDocumento: (documento) =>
      set({ documentos: [...get().documentos, documento] }),

    removeDocumento: (id) =>
      set({
        documentos: get().documentos.filter(
          (doc) => doc.id_documentacion !== id
        ),
      }),

    resetDocumentos: () => set({ documentos: [] }),
  })
);
